import { FC, ReactNode, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import EFPicture from '@elem/ui/ef-picture';
import { ThemeWBProps } from 'eco-design-micro/props/const';

interface ModalProps {
    theme?: ThemeWBProps;
    open: boolean;
    children: ReactNode;
    onClose: () => void;
}
const Modal: FC<ModalProps> = (props) => {
    const { open, children, theme = 'white', onClose } = props;

    const [closeAnimate, setCloseAnimate] = useState(false);

    const getIcon = () => {
        return theme === 'white'
            ? 'https://websiteoss.ecoflow.com/upload/image/1751275755838/white-close-icon.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1749635959325/MultiModal-close-icon.png';
    };
    const handleClose = () => {
        setCloseAnimate(true);
        setTimeout(() => {
            setCloseAnimate(false);
            onClose();
        }, 300);
    };

    return (
        <div className={classNames(styles.multiModal, styles[theme], { [styles.open]: open, [styles['clsoe-animate']]: closeAnimate })}>
            <div className="mask" />
            <div className="modal-content">
                <button className="close-icon" onClick={handleClose}>
                    <EFPicture src={getIcon()} alt="close" />
                </button>
                {children}
            </div>
        </div>
    );
};

export default Modal;
